import { connect } from 'react-redux';
import Login from './Login';
import { submitLogin, resetPassword } from '../../actions/auth';

const mapStateToProps = ({ loginState }) => ({
  loginState,
});

const mapDispatchToProps = dispatch => ({
  submitLogin: (id, { email, password }) => dispatch(submitLogin(email, password)),
  resetPassword: email => dispatch(resetPassword(email)),
});

const LoginContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Login);

export default LoginContainer;



// WEBPACK FOOTER //
// ./src/components/Login/LoginContainer.js